import useMovimentacaoDevolucaoModal, { LOAD_MESSAGE } from './MovimentacaoDevolucaoModalHook'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  Btn,
  CustomCalendar,
  CustomDropdown,
  CustomInputTextArea,
  CustomModal,
  InputNumeroDecimal,
  InputText,
} from '../../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'

function MovimentacaoDevolucaoModal({ dispatch, selectedTp, onResponse, modal }) {
  const { state, localDispatch } = useMovimentacaoDevolucaoModal()

  useEffect(() => {
    if (modal.show) localDispatch.onInit(modal.data)
  }, [modal.show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_PATRIMONIOS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPatrimonios(state.selectedOwner.patrimonio_owner_id)
        break

      case LOAD_MESSAGE.GET_VEHICLE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getVehicles(selectedTp)
        break

      case LOAD_MESSAGE.GET_TRANSPORTADORAS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getTransportadoras(selectedTp)
        break

      case LOAD_MESSAGE.GET_PATRIMONIO_OWNERS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPatrimonioOwners()
        break

      case LOAD_MESSAGE.SAVE_MOVIMENT:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.saveMovimentacaoRecebimento(
          state.movimentacao,
          selectedTp,
          state.selectedVehicle,
          state.selectedOwner,
          state.selectedTransportadora,
          state.patrimonios,
        )
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        onResponse('save', state.updatedMovimentacao)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header={
        state.movimentacao && state.movimentacao.id
          ? 'Editando Movimentação - Devolução'
          : 'Nova Movimentação - Devolução'
      }
      isVisible={modal.show}
      width={600}
      onClose={() => {
        localDispatch.resetModal(modal.data)
        onResponse('close')
      }}
    >
      <div className="p-grid">
        <div className="p-col-6">
          <CustomCalendar
            label={'Data da Movimentação :*'}
            value={state.movimentacao.data_movimentacao}
            onChange={value => localDispatch.onInputChange('data_movimentacao', value)}
          />
        </div>
        <div className="p-col-6">
          <InputText
            label="Número da Viagem :"
            marginTop={9}
            value={state.movimentacao.num_viagem}
            onChange={value => localDispatch.onInputChange('num_viagem', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            label={'Placa Veículo:*'}
            value={state.selectedVehicle}
            onChange={value => {
              localDispatch.onSelectedItemChange('vehicle', value)
            }}
            options={state.vehicles}
            optionLabel={'vehicle_badge'}
            filter={true}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            label={'Transportadora :*'}
            value={state.selectedTransportadora}
            onChange={value => {
              localDispatch.onSelectedItemChange('transportadora', value)
            }}
            options={state.transportadoras}
            optionLabel={'nome'}
            filter={true}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            label={'Dono do Patrimonio :*'}
            value={state.selectedOwner}
            onChange={value => {
              localDispatch.onSelectedItemChange('owner', value)
            }}
            options={state.ownersPatrimonio}
            optionLabel={'patrimonio_owner_name'}
            filter={true}
            disabled={state.movimentacao.id ? true : false}
          />
        </div>
        <div className="p-col-12">
          <CustomInputTextArea
            rows={5}
            label="Observações"
            marginTop={0}
            value={state.movimentacao.observacoes}
            onChange={value => localDispatch.onInputChange('observacoes', value)}
          />
        </div>
        <div className="p-col-12">
          <DataTable
            value={state.patrimonios}
            emptyMessage={'Não existe ativo associado a esta Operação Logística '}
            paginator={true}
            rows={5}
          >
            <Column field={'name'} header={'Ativo Patrimonial'} />
            <Column
              field={'qte_total'}
              header={'Qte'}
              body={patrimonio => (
                <InputNumeroDecimal
                  decimalScale={0}
                  value={patrimonio.qte_total}
                  onChange={value => localDispatch.onPatrimonioChange(patrimonio, value)}
                  marginTop={0}
                />
              )}
              style={tableCellCentered(100)}
            />
          </DataTable>
        </div>
        <div className="p-col-12">
          <Btn onClick={localDispatch.onSalvarClick}>Salvar</Btn>
        </div>
      </div>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })

export default connect(mapStateToProps)(MovimentacaoDevolucaoModal)
